import { useTranslation } from "react-i18next";

const FilterDataHover = ({filter}) => {
    const { t } = useTranslation();

    return (
        <div className="z-30 absolute top-6 hidden flex-col items-center mt-6 group-hover:flex -right-[7.1rem] sm:right-0 w-72">
            <div className="w-7 h-7 -mb-[1.6rem] rotate-45 bg-blue-normal border border-blue-normal -mr-4 sm:-mr-[15.3rem]"></div>
            <div className="rounded-lg space-y-2 relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap w-full bg-blue-normal border border-blue-normal shadow-lg">
                {filter.productCode.length > 0 ? <div className="first-letter:capitalize font-medium">{ t('product code')} : {filter.productCode}</div> : null}
                {filter.description.length > 0 ? <div className="first-letter:capitalize font-medium">{ t('description')} : {filter.description}</div> : null}
                {filter.categoryNameArray.length > 0 ? <div className="first-letter:capitalize font-medium">{ t('categories')} : {filter.categoryNameArray}</div> : null}
                {filter.productGroupNameArray.length > 0 ? <div className="first-letter:capitalize font-medium">{ t('product group a')} : {filter.productGroupNameArray}</div> : null}
            </div>
        </div>
    )
}

export default FilterDataHover;